import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { RoutePages } from 'src/app/enum/route-pages';

@Component({
  selector: 'app-button-add-envelope',
  templateUrl: './button-add-envelope.component.html',
  styleUrls: ['./button-add-envelope.component.scss']
})
export class ButtonAddEnvelopeComponent implements OnInit {

  constructor(private router: Router) { }

  ngOnInit(): void {
  }

  onClickAddEnvelope() {
    this.router.navigate([RoutePages.MainEnvelope]);
  }
}
